module.exports = __webpack_public_path__ + "img/banner_3.69d91089.jpg";